import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMountain = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 526,
	height: 314,
	fill: "none",
	viewBox: "0 0 526 314",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffc14a",
			d: "M462.56 184.75a78.4 78.4 0 1 1-156.8 0 78.4 78.4 0 0 1 156.8 0"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 507.72,
			cy: 184.78,
			fill: "#ffc14a",
			rx: 10.12,
			ry: 17.7,
			transform: "rotate(90 507.72 184.78)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 487.72,
			cy: 253.06,
			fill: "#ffc14a",
			rx: 10.12,
			ry: 17.7,
			transform: "rotate(122.7 487.72 253.06)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 433.81,
			cy: 299.81,
			fill: "#ffc14a",
			rx: 10.12,
			ry: 17.7,
			transform: "rotate(155.4 433.8 299.81)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 362.82,
			cy: 309.9,
			fill: "#ffc14a",
			rx: 10.12,
			ry: 17.7,
			transform: "rotate(-171.8 362.82 309.9)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 298.14,
			cy: 280.07,
			fill: "#ffc14a",
			rx: 10.12,
			ry: 17.7,
			transform: "rotate(-139 298.14 280.07)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 259.83,
			cy: 220.14,
			fill: "#ffc14a",
			rx: 10.12,
			ry: 17.7,
			transform: "rotate(-106.2 259.83 220.14)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 260.1,
			cy: 148.49,
			fill: "#ffc14a",
			rx: 10.12,
			ry: 17.7,
			transform: "rotate(-73.3 260.1 148.49)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 298.8,
			cy: 88.9,
			fill: "#ffc14a",
			rx: 10.12,
			ry: 17.7,
			transform: "rotate(-40.6 298.8 88.9)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 364,
			cy: 59.49,
			fill: "#ffc14a",
			rx: 10.12,
			ry: 17.7,
			transform: "rotate(-7.7 364 59.5)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 434.43,
			cy: 70.04,
			fill: "#ffc14a",
			rx: 10.12,
			ry: 17.7,
			transform: "rotate(25 434.43 70.04)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 488.19,
			cy: 117.24,
			fill: "#ffc14a",
			rx: 10.12,
			ry: 17.7,
			transform: "rotate(57.7 488.19 117.24)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M9.01 205.08c0-1.14.9-2.08 2.04-2.12l4-.17a2.2 2.2 0 1 1 .08 4.42h-4a2.13 2.13 0 0 1-2.12-2.13"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#237d45",
			d: "M22.1 174.34H4.2c-3.12 0-4.76-3.8-2.71-6.15a85 85 0 0 0 4.16-5.12 97 97 0 0 0 4.27-6.52 3.74 3.74 0 0 1 6.3-.08 133 133 0 0 0 4.46 6.6c1.2 1.63 2.72 3.51 4.18 5.27 1.95 2.36.3 6-2.76 6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#237d45",
			d: "m-4.94 183.59 15.22-18.5a3.54 3.54 0 0 1 5.48.02l15.12 18.49c1.8 2.2.4 5.5-2.42 5.77l-15.11 1.4h-.65l-15.23-1.4a3.54 3.54 0 0 1-2.41-5.78"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#237d45",
			d: "M29.89 199.87c-14.13 2.63-19.98 3.15-34.43.07a3.48 3.48 0 0 1-1.7-5.9l6.32-6.24 10.16-10.68a3.54 3.54 0 0 1 5.21.08l9.46 10.6 6.68 5.95a3.54 3.54 0 0 1-1.7 6.12"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M9.03 205.13c0-1.14.9-2.08 2.04-2.13l3.99-.16a2.2 2.2 0 1 1 .09 4.41h-4a2.13 2.13 0 0 1-2.12-2.12"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_25837_69672",
			width: 41,
			height: 49,
			x: -8,
			y: 154,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#275653",
				fillRule: "evenodd",
				d: "M9.94 156.6a3.74 3.74 0 0 1 6.3-.09 122 122 0 0 0 4.46 6.6 119 119 0 0 0 4.17 5.28 3.68 3.68 0 0 1-1.68 5.84l7.7 9.41c1.8 2.2.4 5.51-2.42 5.77l-1.62.15 4.76 4.24a3.54 3.54 0 0 1-1.7 6.12c-14.13 2.63-19.98 3.15-34.43.07a3.48 3.48 0 0 1-1.7-5.9l4.65-4.6-.95-.08a3.54 3.54 0 0 1-2.4-5.78l7.81-9.5a3.75 3.75 0 0 1-1.39-5.89 85 85 0 0 0 4.17-5.13 97 97 0 0 0 4.27-6.51",
				clipRule: "evenodd"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_25837_69672)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#1d1d1d",
				fillOpacity: .39,
				d: "M12.73 201.66c-1.48-14.18-15.1-19.59 4.08-47.14 9.1-10.59 19.8-25.78-10.72-1.92-38.15 29.82 8.11 63.07 6.64 49.06"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M51.7 184.62c0-1.26 1-2.3 2.26-2.36l7.62-.31a2.36 2.36 0 0 1 2.46 2.36v1.86c0 1.3-1.06 2.36-2.36 2.36h-7.62a2.36 2.36 0 0 1-2.36-2.36z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#237d45",
			d: "M74.9 139.84H40.56c-3.12 0-4.76-3.78-2.67-6.1a155 155 0 0 0 8.82-10.6 166 166 0 0 0 7.84-12.17 3.68 3.68 0 0 1 6.25-.09 226 226 0 0 0 8.2 12.26c2.46 3.35 5.83 7.44 8.63 10.73a3.62 3.62 0 0 1-2.73 5.97"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#237d45",
			d: "m28.97 156.02 25.92-31.47a3.54 3.54 0 0 1 5.48 0l25.74 31.49c1.8 2.2.41 5.5-2.41 5.76l-25.74 2.39q-.32.03-.65 0l-25.93-2.39a3.54 3.54 0 0 1-2.41-5.78"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#237d45",
			d: "M86.02 177.02c-24.46 4.64-32.56 5.64-57.4.1a3.5 3.5 0 0 1-1.7-5.93l11.54-11.4 16.34-17.17a3.54 3.54 0 0 1 5.2.08l15.26 17.08 12.47 11.12a3.55 3.55 0 0 1-1.71 6.12"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M51.72 184.7c0-1.27 1-2.31 2.27-2.36l7.62-.32a2.36 2.36 0 0 1 2.45 2.36v1.86c0 1.3-1.05 2.36-2.36 2.36h-7.6a2.36 2.36 0 0 1-2.37-2.36z"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask1_25837_69672",
			width: 64,
			height: 72,
			x: 25,
			y: 109,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#275653",
				fillRule: "evenodd",
				d: "M54.58 111.04a3.68 3.68 0 0 1 6.26-.09c2.32 3.7 5.51 8.64 8.17 12.26 2.46 3.35 5.83 7.44 8.63 10.73a3.62 3.62 0 0 1-2.72 5.97h-2.03l13.24 16.2c1.8 2.2.42 5.5-2.4 5.76l-5.6.52 9.62 8.58a3.55 3.55 0 0 1-1.7 6.12c-24.47 4.64-32.57 5.64-57.4.1a3.5 3.5 0 0 1-1.7-5.93l9.07-8.96-4.62-.43a3.54 3.54 0 0 1-2.4-5.78l13.33-16.18h-1.74c-3.12 0-4.76-3.78-2.67-6.1a152 152 0 0 0 8.82-10.6 164 164 0 0 0 7.84-12.17",
				clipRule: "evenodd"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask1_25837_69672)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#1d1d1d",
				fillOpacity: .39,
				d: "M57.21 180.31c-2.2-21-22.38-29.02 6.03-69.84C76.73 94.8 92.6 72.3 47.38 107.63c-56.53 44.18 12.01 93.44 9.83 72.68"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m-18.27 218.49 2.61 26.18A16.6 16.6 0 0 0 .55 259.6l423.93 7.28c15.15.26 22.68-18.28 11.63-28.66l-104.3-98.02a7 7 0 0 0-8.92-.57 7 7 0 0 1-7.92.2l-43.92-28.46a16.6 16.6 0 0 1-7.44-15.92l1.18-9.64a16.6 16.6 0 0 0-6.38-15.18L244 59.61a16.6 16.6 0 0 0-20.93.62l-19.14 16.55a17 17 0 0 1-5.33 3.1l-52.22 18.4a16.6 16.6 0 0 0-8.2 6.31l-17.76 26.12a16.6 16.6 0 0 1-13.39 7.25l-18.82.36a16.6 16.6 0 0 0-9.06 2.9l-90.31 61.94c-5 3.43-7.73 9.3-7.12 15.33"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask2_25837_69672",
			width: 352,
			height: 215,
			x: 11,
			y: 25,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#f5f5f5",
				d: "m11.29 188.8 2.62 50.34 348.57-22.26-77.46-109.5-6.89 6.42-43.42-35.09 3.58-29.34-24.92-24.04-25.59 28.17-47.83 22.78-21.1 38.27-25.37 1.48z"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask2_25837_69672)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#f2f1f1",
				d: "m68.32 191.35-21.78-15.97c-5.37-3.93-8.76-10.29-6.7-16.61C54.6 113.35 154.84 40.63 213.52 8.9c8.19-4.43 18.21-2.3 24.33 4.7l8.18 9.37a20.73 20.73 0 0 1-4.5 31.12L207.37 75.8a20.73 20.73 0 0 0-7 27.55l21.7 39.1a8.32 8.32 0 0 1-12.1 10.8l-12.37-8.83a8.7 8.7 0 0 0-9.5-.37 8.7 8.7 0 0 1-9.14-.12L161.1 132.5a14 14 0 0 0-20.34 6.1 14 14 0 0 1-3.65 4.9l-7.48 6.45a8.8 8.8 0 0 1-6.8 2.06 8.78 8.78 0 0 0-9.52 11.09l1.61 5.74a12.75 12.75 0 0 1-6.46 14.79l-18.44 9.44a20.7 20.7 0 0 1-21.7-1.72"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#f2f1f1",
			d: "m327.45 265.01-18.9.28-340.24 4.94-18.9.27a12 12 0 0 0-8.67 3.87 12.8 12.8 0 0 0-3.23 9.21 12.8 12.8 0 0 0 4.1 8.87 12 12 0 0 0 8.98 3.03l18.85-1.53 339.17-27.42z"
		})
	]
});
export default SvgMountain;
